import { Manufacturer } from 'models/Manufacturer';
import { ApiPayload } from 'infrastructure/api/ApiTypes';
import { Api } from 'infrastructure/api/Api'

export const ManufacturerActionType = {
    FETCH_MANUFACTURERS: 'FETCH_MANUFACTURERS',
    FETCH_MANUFACTURERS_SUCCESS: 'FETCH_MANUFACTURERS_SUCCESS',
    ADD_MANUFACTURER: 'ADD_MANUFACTURER',
    ADD_MANUFACTURER_SUCCESS: 'ADD_MANUFACTURER_SUCCESS',
    EDIT_MANUFACTURER: 'EDIT_MANUFACTURER',
    EDIT_MANUFACTURER_SUCCESS: 'EDIT_MANUFACTURER_SUCCESS',
    DELETE_MANUFACTURER: 'DELETE_MANUFACTURER',
    DELETE_MANUFACTURER_SUCCESS: 'DELETE_MANUFACTURER_SUCCESS',
    API_ERROR: 'API_ERROR',
};

interface IFetchManufacturersAction {
    type: typeof ManufacturerActionType.FETCH_MANUFACTURERS
    payload: ApiPayload,
    returnPayload: Manufacturer[],
    meta: {
        isApiCall: boolean
    },
}

interface IAddManufacturersAction {
    type: typeof ManufacturerActionType.ADD_MANUFACTURER
    payload: ApiPayload,
    returnPayload: Manufacturer,
    meta: {
        isApiCall: boolean
    },
}

interface IDeleteManufacturersAction {
    type: typeof ManufacturerActionType.DELETE_MANUFACTURER
    payload: ApiPayload,
    returnPayload: Manufacturer,
    meta: {
        isApiCall: boolean
    },
}

export type IManufacturerActions = IFetchManufacturersAction | IAddManufacturersAction | IDeleteManufacturersAction

const baseUrl = 'api/manufacturers';
export class ManufacturerActions {
    public static fetchManufacturers(token: string): IManufacturerActions {
        return {
            type: ManufacturerActionType.FETCH_MANUFACTURERS,
            payload: Api.fetchApiCall(baseUrl, token, ManufacturerActionType.FETCH_MANUFACTURERS_SUCCESS, ManufacturerActionType.API_ERROR),
            returnPayload: [],
            meta: {
                isApiCall: true
            },
        }
    }

    public static addManufacturer(token: string, manufacturer: Manufacturer): IManufacturerActions {
        return {
            type: ManufacturerActionType.ADD_MANUFACTURER,
            payload: Api.postApiCall(baseUrl, token, ManufacturerActionType.ADD_MANUFACTURER_SUCCESS, ManufacturerActionType.API_ERROR, manufacturer),
            returnPayload: Manufacturer.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static editManufacturer(token: string, manufacturer: Manufacturer): IManufacturerActions {
        return {
            type: ManufacturerActionType.EDIT_MANUFACTURER,
            payload: Api.putApiCall(baseUrl + '/' + manufacturer.id, token, ManufacturerActionType.EDIT_MANUFACTURER_SUCCESS, ManufacturerActionType.API_ERROR, manufacturer),
            returnPayload: Manufacturer.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static deleteManufacturer(token: string, id: number): IManufacturerActions {
        return {
            type: ManufacturerActionType.DELETE_MANUFACTURER,
            payload: Api.deleteApiCall(baseUrl + '/' + id, token, ManufacturerActionType.DELETE_MANUFACTURER_SUCCESS, ManufacturerActionType.API_ERROR, true),
            returnPayload: Manufacturer.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

}